import { render, staticRenderFns } from "./CorrPricer.vue?vue&type=template&id=808f03d2&scoped=true&"
import script from "./CorrPricer.vue?vue&type=script&lang=js&"
export * from "./CorrPricer.vue?vue&type=script&lang=js&"
import style0 from "./CorrPricer.vue?vue&type=style&index=0&id=808f03d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808f03d2",
  null
  
)

export default component.exports